import React from "react";
import MemberDashboard from "@/components/MemberDashboard";

export default function CreatorDashboard() {
  return <MemberDashboard role="beauty_creator" />;
}
